import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "delete clock outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-delete-clock-outline',
    templateUrl: './icon-delete-clock-outline.component.html',
    styleUrls: ['./icon-delete-clock-outline.component.scss'],
    standalone: false
})
export class IconDeleteClockOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
